import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=117a63e2&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"
import style0 from "./Notification.vue?vue&type=style&index=0&id=117a63e2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117a63e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jissjohnson/code/Zenrion/CareKraft/zenrion-erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('117a63e2')) {
      api.createRecord('117a63e2', component.options)
    } else {
      api.reload('117a63e2', component.options)
    }
    module.hot.accept("./Notification.vue?vue&type=template&id=117a63e2&scoped=true", function () {
      api.rerender('117a63e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Notification.vue"
export default component.exports